var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSoluciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    y: 0.505066,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2059 34.4389L35.6704 37.9744L45.6641 47.9681L49.1996 44.4326L39.2059 34.4389Z",
    fill: "#043873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8659 29.3546C45.0826 29.3546 47.6992 26.7379 47.6992 23.5213C47.6992 22.5546 47.4326 21.6546 47.0159 20.8546L42.5159 25.3546L40.0326 22.8713L44.5326 18.3713C43.7326 17.9546 42.8326 17.6879 41.8659 17.6879C38.6492 17.6879 36.0326 20.3046 36.0326 23.5213C36.0326 24.2046 36.1659 24.8546 36.3826 25.4546L33.2992 28.5379L30.3326 25.5713L31.5159 24.3879L29.1659 22.0379L32.6992 18.5046C30.7492 16.5546 27.5826 16.5546 25.6326 18.5046L19.7326 24.4046L22.0826 26.7546H17.3826L16.1992 27.9379L22.0992 33.8379L23.2826 32.6546V27.9379L25.6326 30.2879L26.8159 29.1046L29.7826 32.0713L17.4326 44.4213L20.9659 47.9546L39.9326 29.0046C40.5326 29.2213 41.1826 29.3546 41.8659 29.3546Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoluciones);
export default __webpack_public_path__ + "static/media/icon-soluciones.8d8d6aece26155d76f8ba9cdff29da22.svg";
export { ForwardRef as ReactComponent };